<template>
    <MContainer class="mt-5 gap-2">
        <FloatLabel class="w-full">
            <InputText id="addPatientDialogName" class="w-full" v-model="form.firstName" type="text" />
            <label for="value">{{ $t("shared.firstName") }}</label>
        </FloatLabel>
        <FloatLabel class="w-full">
            <InputText id="addPatientDialogLastName" class="w-full" v-model="form.lastName" type="text" />
            <label for="value">{{ $t("shared.lastName") }}</label>
        </FloatLabel>
        <FloatLabel class="w-full">
            <DatePicker id="value" dateFormat="dd/mm/yy" class="w-full" v-model="form.dateOfBirth" />
            <label for="value">{{ $t("web-rg.dateOfBirthDdmmyyyy") }}</label>
        </FloatLabel>
    </MContainer>
    <MContainer class="mt-7 gap-2">
        <FloatLabel class="w-full">
            <Textarea v-model="form.notes" class="w-full" rows="6" />
            <label>{{ $t("shared.notes") }}</label>
        </FloatLabel>
    </MContainer>
    <Divider />
    <MContainer class="justify-center gap-2 mt-7">
        <MDialogConfirmButtonRedesign id="addPatientDialogToDataImport" v-bind:label="$t('web-rg.toDataImport')" :icon="'pi pi-check'" v-on:click="toDataImport()" />
        <MDialogCancelButtonRedesign v-bind:label="$t('shared.cancel')" :icon="'pi pi-times'" v-on:click="dialogRef.close()" />
    </MContainer>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { MContainer, MDialogCancelButtonRedesign, MDialogConfirmButtonRedesign, MUButton } from "@xlabmedical/medic-web-framework";
import type { DynamicDialogOptions } from "primevue/dynamicdialogoptions";
import FloatLabel from "primevue/floatlabel";
import DatePicker from "primevue/datepicker";

const dialogRef = inject("dialogRef") as DynamicDialogOptions;

export interface formData {
    firstName: string;
    lastName: string;
    dateOfBirth?: Date;
    notes: string;
}

const emits = defineEmits<{ (e: "nextStep", value: formData): void }>();

const form = ref<formData>({
    firstName: "",
    lastName: "",
    notes: "",
});

const toDataImport = () => {
    emits("nextStep", form.value);
    dialogRef.value.close();
};
</script>

<style scoped>
:deep(.p-inputtext) {
    border: 2px #868c9b solid !important;
}
</style>
